import { APIS } from "../endpoints";
import api from "./api";

export const getLoadFileData = async (page,limit,searchText) => {
const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchText) {
        formData.append('search', searchText); // Add search term
    }
   const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.adminLoadData}`, {
        params: params
    });

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const uploadFile = async (data) => {
  try {
    const formData = new FormData();
    formData.append("derivedFile", data);

    const result = await api.post(`${APIS.BASE_URL}${APIS.adminLoadData}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return result || [];
  } catch (error) {
    console.error("Upload failed:", error);
    return [];
  }
};
  //Post api call for Algolia Trigger
  export const postAlgoliaTrigger = async (id, file_name, type) => {
    const result = await api.post(`${APIS.BASE_URL}${APIS.adminAlgoliaTrigger}`, {
      id,
      file_name,
      type,
    });
    return result || [];
  };
